/** @format */

import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Path } from "utils/constant.data";
import { ReactComponent as Logo } from "images/svg/logo.svg";
import { ReactComponent as Coil } from "images/svg/coil.svg";
import Se from "images/new/se.png";
import Se1 from "images/new/see.png";
import Se2 from "images/new/seer.png";
import Se3 from "images/new/coil.png";
import Se4 from "images/new/seere.png";
import Se7 from "images/new/star.png";

const AuthHeader = ({ showButton = true, showLogin = false }) => {
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const Patterns = () => {
    return (
      <>
        <figure className="bg-tip four">
          <img src={Se3} alt="Background" />
        </figure>

        <figure className="bg-tip three">
          <img src={Se2} alt="Background" />
        </figure>

        <figure className="bg-tip one">
          <img src={Se} alt="Background" />
        </figure>

        <figure className="bg-tip two">
          <img src={Se1} alt="Background" />
        </figure>

        <figure className="bg-tip six">
          <img src={Se3} alt="Background" />
        </figure>

        <figure className="bg-tip seven">
          <img src={Se7} alt="Background" />
        </figure>

        <figure className="bg-tip five">
          <img src={Se4} alt="Background" />
        </figure>
      </>
    );
  };

  return (
    <>
      {/* <Patterns /> */}
      {
        showLogin ? (
      <div className="auth-header w-100">
        <figure className="logo">
          <Link to={Path.LOGIN}>
            <Logo />
          </Link>
        </figure>

        <button
          onClick={() => navigate(Path.LOGIN)}
          className="btn btn-outline"
        >
          Login Here
        </button>
        <div className="pointer-container">
          <Coil />
          <div className="pointer-text">
            <p className="subtitle">Do you have an account?</p>
            <h6 className="title">No need to register a new one, Login here</h6>
          </div>
         
        </div>
      </div>
        ) : (
          <div className="auth-header w-100">
        <figure className="logo">
          <Link to={Path.LOGIN}>
            <Logo />
          </Link>
        </figure>

        <button
          onClick={() => navigate(Path.APPLY)}
          className="btn btn-outline"
        >
          Register Here
        </button>
        <div className="pointer-container">
          <Coil />
          <div className="pointer-text">
            <p className="subtitle">Don’t have an account yet?</p>
            <h6 className="title">No worries, start with a registration</h6>
          </div>
         
        </div>
      </div>
        )
      }
      
      {showButton && (
        <div className="auth-header no-pad w-100 return-div">
          <button
            onClick={() => navigate(Path.LOGIN)}
            className="btn btn-outline"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.375 11.9991C21.375 12.2974 21.2565 12.5836 21.0455 12.7946C20.8345 13.0055 20.5484 13.1241 20.25 13.1241H6.46878L11.2988 17.9531C11.5101 18.1645 11.6289 18.4511 11.6289 18.75C11.6289 19.0489 11.5101 19.3355 11.2988 19.5469C11.0874 19.7582 10.8008 19.877 10.5019 19.877C10.203 19.877 9.91638 19.7582 9.70503 19.5469L2.95503 12.7969C2.85015 12.6924 2.76694 12.5682 2.71016 12.4314C2.65337 12.2947 2.62415 12.1481 2.62415 12C2.62415 11.8519 2.65337 11.7053 2.71016 11.5686C2.76694 11.4318 2.85015 11.3076 2.95503 11.2031L9.70503 4.45312C9.80968 4.34848 9.93391 4.26547 10.0706 4.20883C10.2074 4.1522 10.3539 4.12305 10.5019 4.12305C10.6499 4.12305 10.7964 4.1522 10.9332 4.20883C11.0699 4.26547 11.1941 4.34848 11.2988 4.45312C11.4034 4.55777 11.4864 4.682 11.5431 4.81873C11.5997 4.95546 11.6289 5.102 11.6289 5.25C11.6289 5.39799 11.5997 5.54454 11.5431 5.68126C11.4864 5.81799 11.4034 5.94223 11.2988 6.04687L6.46878 10.8741H20.25C20.5484 10.8741 20.8345 10.9926 21.0455 11.2036C21.2565 11.4145 21.375 11.7007 21.375 11.9991Z"
                fill="#59656E"
              />
            </svg>
            Back to Login
          </button>
        </div>
      )}
    </>
  );
};

export default AuthHeader;
